import React, { Component } from 'react';
import styled from 'styled-components';

import Map from 'components/Map/Map';
import Hero from 'components/Hero';
import Content from 'components/Content';
import UpcomingProject from 'components/UpcomingProject';
import Team from 'components/Team';
import Form from 'components/Form';
import Footer from 'components/Footer';
import media from '../styles/media';
import Header from 'components/Header';

class Home extends Component {
  render() {
    return (
      <main>
        <Header />
        <BackgroundContainer>
          <Hero />
          <Content />
          <UpcomingProject />
        </BackgroundContainer>
        <Map />
        <Team />
        <Footer />
      </main>
    );
  }
}

const BackgroundContainer = styled.div`
  position: relative;
  &:before {
    content: '';
    opacity: 0.9;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('/assets/images/backgroundContent.jpg');
    background-size: contain;
    overflow-y: hidden;
    background-attachment: fixed;
  }
  /* opacity: 0.9; */
  @media (min-width: ${media.md}) {
    padding-bottom: 110px;
  }
`;

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js